// Upload will always provided a uri of /videos/<MEDIA_ID>
export const selectMediaIdFromUri = (uri: string) => uri.replace('/videos/', '')

export const vimeoBaseUrl = 'https://api.vimeo.com/videos'

export const getReplaceUrl = (videoId: string) =>
  `${vimeoBaseUrl}/${videoId}/versions`
